import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { CbseComponent } from './view/cbse/cbse.component';
import { ContactUsComponent } from './view/contact-us/contact-us.component';
import { BlogItemComponent } from './view/home/blog/blog-item/blog-item.component';
import { HomeComponent } from './view/home/home.component';
import { PrivacyComponent } from './view/privacy/privacy.component';
import { RefundComponent } from './view/refund/refund.component';
const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  scrollOffset: [0, 64],
};


const routes: Routes = [
  {path:'',component:HomeComponent},
  {path:'accomplishment',loadChildren:'./modules/accomplishment/accomplishment.module#AccomplishmentModule'},
  {path:'faculty',loadChildren:'./modules/faculty/faculty.module#FacultyModule'},
  {path:'campus',loadChildren:'./modules/campus/campus.module#CampusModule'},
  {path:'achievements',loadChildren:'./modules/achievements/achievements.module#AchievementsModule'},
  {path:'glimpses',loadChildren:'./modules/glimpses/glimpses.module#GlimpsesModule'},
  {path:'admission',loadChildren:'./modules/admission/admission.module#AdmissionModule'},
  {path:'gallery',loadChildren:'./modules/gallery/gallery.module#GalleryModule'},
  {path:'labs',loadChildren:'./modules/labs/labs.module#LabsModule'},
  {path:'about-us',loadChildren:'./modules/about/about.module#AboutModule'},
  {path:'not-found',loadChildren:'./modules/shared/shared.module#SharedModule'},
  {path:'contact-us',component:ContactUsComponent},
  {path:'Mandatory-Public-Disclosure',component:CbseComponent},
  {path:'blog/:id',component:BlogItemComponent},
  {path:'privacy-policy',component:PrivacyComponent},
  {path:'refund-policy',component:RefundComponent},
  {path:'blog/:id',component:BlogItemComponent},
  // {path:'not-found',component:NotFoundComponent},
  {path:'**',redirectTo:'/not-found',pathMatch:'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
